/* eslint-disable no-param-reassign,consistent-return */
import { createSlice, createAsyncThunk, Draft, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { Modal } from "antd";
import { LoadingStatusCode } from "../../lib/types/LoadingStatusCode";
import LoadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { Config } from "../../lib/interfaces/Config";

interface InitialState {
  configLoading: LoadingStatusCode;
  config: Config;
}

const initialState: InitialState = {
  configLoading: LoadingStatusCodes.idle,
  config: {
    phoneMasks: {
      "1": { country: "+1", phone: "(111) 111-11-11", full: "+1 (111) 111-11-11" },
      "7": { country: "+1", phone: "(111) 111-11-11", full: "+1 (111) 111-11-11" },
      default: { country: "+1", phone: "(111) 111-11-11", full: "+1 (111) 111-11-11" },
    },
  },
};

export const fetchConfigData = createAsyncThunk("config/fetchConfigData", async () => {
  try {
    const response = axios(`${process.env.PUBLIC_URL}/mainConfig.json`);
    const { data }: { data: Config } = await response;
    return data;
  } catch (e) {
    const errorOptions = {
      title: "Ошибка загрузки файла конфигурации",
      content: "Что-то пошло не так... ",
    };
    if (e instanceof Error) {
      errorOptions.content = e.message;
    }
    Modal.error(errorOptions);
    throw new Error(errorOptions.content);
  }
});

export const slice = createSlice({
  name: "config",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchConfigData.pending, (state) => {
        state.configLoading = LoadingStatusCodes.pending;
      })
      .addCase(fetchConfigData.rejected, (state) => {
        state.configLoading = LoadingStatusCodes.rejected;
      })
      .addCase(fetchConfigData.fulfilled, (state: Draft<any>, action: PayloadAction<Config>) => {
        state.configLoading = LoadingStatusCodes.fulfilled;
        state.config = action.payload;
      }),
});

const { reducer, actions: configActions } = slice;

export default reducer;
export { configActions };
